// 统一管理 API 和 WebSocket 基础地址
//
// 线上构建：只认 Vite --mode（development / test / production），地址写死在下方映射表，
// 不受本地 .env 影响。
// 本地运行（npm run dev / test / prod）：可用 .env.[mode] 或 .env.[mode].local 覆盖。

const ENV_URLS = {
  development: {
    api: 'https://dev.harvedex.cn',
    ws: 'wss://dev.harvedex.cn',
  },
  test: {
    api: 'https://test.harvedex.cn',
    ws: 'wss://test.harvedex.cn',
  },
  production: {
    api: 'https://prod.harvedex.cn',
    ws: 'wss://prod.harvedex.cn',
  },
}

const modeUrls = ENV_URLS[import.meta.env.MODE] || ENV_URLS.production

export const API_BASE_URL =
  import.meta.env.DEV && import.meta.env.VITE_API_BASE_URL
    ? import.meta.env.VITE_API_BASE_URL
    : modeUrls.api

export const WS_BASE_URL =
  import.meta.env.DEV && import.meta.env.VITE_WS_BASE_URL
    ? import.meta.env.VITE_WS_BASE_URL
    : modeUrls.ws

// API 超时配置
export const API_TIMEOUT = parseInt(import.meta.env.VITE_API_TIMEOUT) || 15000
export const STORAGE_TIMEOUT = parseInt(import.meta.env.VITE_STORAGE_TIMEOUT) || 30000

// Google Maps 配置
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY

// Mapbox 配置
export const MAP_BOX_ACCESS_TOKEN = 'pk.eyJ1IjoiZ290ZW5nIiwiYSI6ImNtbDk1eDJrdzAwYTUzY3B6bzBwejJrMHkifQ.Sn_H1zFLzt_PylKg8sOtLw'

// 是否开启组织管理
export const OPEN_ORG_MANAGEMENT = true

// 是否显示多工作区功能
export const SHOW_MULTI_WORKSPACE = true

// 是否开启虚拟数据功能
export const ENABLE_VIRTUAL_DATA = true

// 是否能在地图上全量修改元素（含场站上下文：其他 map / 道路 / 通道 / 充电桩等）
// true：PGM/点云下可点选拖动调整；false：仅展示不可编辑
export const ENABLE_FULL_EDIT_ELEMENT = false

// 是否启用连续打点
export const IS_ENABLE_DEVICE_CONTINUOUS_MARK = true

// 验证码长度（与 App 端 verifyCodeLength 对齐，可按环境改为 4 或 6）
export const VERIFY_CODE_LENGTH = 6
